<template>
    <div class="position-relative">
        <div v-if="countCreatedResponse<4" class="root-preloader position-absolute overlay-loader-wrapper">
            <div class="spinner-bounce d-flex align-items-center dashboard-preloader justify-content-center">
                <span class="bounce1 mr-1"/>
                <span class="bounce2 mr-1"/>
                <span class="bounce3 mr-1"/>
                <span class="bounce4"/>
            </div>
        </div>
        <div class="content-wrapper">
            <app-breadcrumb :page-title="$t('dashboard')" :directory="$t('dashboard')" :icon="'pie-chart'"/>

            <task-form-progress v-if="showProgress == true" :actionType="true" :task_id="task_id" :taskForms="taskForms" :formProgress="formProgress" :overallProgress="overallProgress"></task-form-progress>
            <div class="row">
                <app-overlay-loader v-if="!isActivedDefaultiInfo && !mainPreloader"/>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-4" v-if="isActivedDefaultiInfo">

                  <div v-for="(item, index) in e_commerceDashboard.defaultInfo.topSectionData" :key="index">
                        <!-- <a :href="item.url" target="_blank" style="color:#000"> -->
                            <app-widget class="mb-primary"
                                :type="'app-widget-with-icon'"
                                :label="item.label"
                                :number="item.number"
                                :icon="item.icon"/>
                        <!-- </a> -->
                    </div>
                </div>
                <!-- <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-8 mb-primary">
                    <app-overlay-loader v-if="!isActiveBusinessOverview && !mainPreloader"/>
                    <div class="card card-with-shadow border-0 h-100" v-if="isActiveBusinessOverview">
                        <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
                            <h5 class="card-title mb-0">{{ $t('business_overview') }}</h5>
                            <ul class="nav tab-filter-menu justify-content-flex-end">
                                <li class="nav-item"
                                    v-for="(item, index) in e_commerceDashboard.businessOverview.chartFilterOptions"
                                    :key="index">
                                    <a href="#"
                                       class="nav-link py-0"
                                       :class="[businessFilter == item.id ? 'active' : index === 0 && businessFilter === '' ? 'active': '']"
                                       @click.prevent="businessFilterValue(item.id)">
                                        {{ item.value }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="card-body">
                            <app-chart class="mb-primary"
                                       type="custom-line-chart"
                                       :height="180"
                                       :labels="e_commerceDashboard.businessOverview.labels"
                                       :data-sets="e_commerceDashboard.businessOverview.chartData"/>

                            <div class="chart-data-list d-flex flex-wrap justify-content-center">
                                <div class="data-group-item" style="color: #ff9700;">
                                    <span class="square" style="background-color: #ff9700;"/>
                                    {{ $t('sales') }}
                                    <span class="value">{{e_commerceDashboard.businessOverview.salesCount}}</span>
                                </div>
                                <div class="data-group-item" style="color: #348cd4;">
                                    <span class="square" style="background-color: #348cd4;"/>
                                    {{ $t('profit') }}
                                    <span class="value">{{e_commerceDashboard.businessOverview.profitsCount}}</span>
                                </div>
                                <div class="data-group-item" style="color: #f7531e;">
                                    <span class="square" style="background-color: #f7531e;"/>
                                    {{ $t('purchase') }}
                                    <span class="value">{{e_commerceDashboard.businessOverview.purchaseCount}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="flex flex-column mb-5 mt-4 faq-section">
        <div class="row">
          <div class="col-md-12">
            <div id="accordion">
              <div class="card">
                <div class="card-header" id="heading-1">
                  <h5 class="mb-0">
                    <a role="button" class="heading-style" data-toggle="collapse" href="#collapse-1" aria-expanded="true" aria-controls="collapse-1">
                      Tasks</a>
                  </h5>
                </div>
                <div id="collapse-1" class="collapse show" data-parent="#accordion" aria-labelledby="heading-1">
                  <div class="card-body">
                    <app-overlay-loader v-if="!isActivedDefaultiInfo && !mainPreloader"/>
                    <div class="row" v-if="isActivedDefaultiInfo">
                      <div
                        class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-3"
                        v-for="(item, index) in e_commerceDashboard.defaultInfo.taskSectionData"
                        :key="index"
                      >
                        <div class="cards-wrapper w-100 d-block">
                        <a :href="item.url" target="_blank" style="color:#000">
                          <app-widget
                            class="mb-primary"
                            :type="'app-widget-with-icon'"
                            :label="item.label"
                            :number="item.number"
                            :icon="item.icon"
                          />
                        </a>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="heading-2">
                  <h5 class="mb-0">
                    <a class="collapsed heading-style" role="button" data-toggle="collapse" href="#collapse-2" aria-expanded="false" aria-controls="collapse-2">
                      Jobs</a>
                  </h5>
                </div>
                <div id="collapse-2" class="collapse" data-parent="#accordion" aria-labelledby="heading-2">
                  <div class="card-body">
                    <app-overlay-loader v-if="!isActivedDefaultiInfo && !mainPreloader"/>
                      <div class="row" v-if="isActivedDefaultiInfo">
                        <div
                          class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-3"
                          v-for="(item, index) in e_commerceDashboard.defaultInfo.jobSectionData"
                          :key="index"
                        >
                          <div class="cards-wrapper w-100 d-block">
                          <a :href="item.url" target="_blank" style="color:#000">
                            <app-widget
                              class="mb-primary"
                              :type="'app-widget-with-icon'"
                              :label="item.label"
                              :number="item.number"
                              :icon="item.icon"
                            />
                          </a>
                            </div>
                        </div>
                      </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>

            <app-overlay-loader v-if="!isActivedDefaultiInfo && !mainPreloader"/>
            <div class="row" v-if="isActivedDefaultiInfo">
                <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-3"
                     v-for="(item, index) in e_commerceDashboard.defaultInfo.middleSectionData" :key="index">
                     <a :href="item.url" target="_blank" style="color:#000">
                        <app-widget class="mb-primary"
                            :type="'app-widget-without-icon'"
                            :label="item.label"
                            :number="item.number"
                        />
                    </a>
                </div>
            </div>

            <div class="row" v-if="isActivedDefaultiInfo">
                <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-3"
                     v-for="(item, index) in e_commerceDashboard.defaultInfo.bottomSectionData" :key="index">
                    <app-widget class="mb-primary"
                                :type="'app-widget-with-circle'"
                                :label="item.label"
                                :number="item.number"/>
                </div>
            </div>

            <div class="row">
                <!-- <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-8 mb-4 mb-md-0">
                    <app-overlay-loader v-if="!isActiveContactOverview && !mainPreloader"/>
                    <div class="card card-with-shadow border-0 h-100" v-if="isActiveContactOverview">
                        <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
                            <h5 class="card-title mb-0">{{ $t('contact_overview') }}</h5>
                            <ul class="nav tab-filter-menu justify-content-flex-end">
                                <li class="nav-item"
                                    v-for="(item, index) in e_commerceDashboard.contactOverview.chartFilterOptions"
                                    :key="index">
                                    <a href="#"
                                       class="nav-link py-0"
                                       :class="[contactFilter == item.id ? 'active' : index === 0 && contactFilter === '' ? 'active': '']"
                                       @click.prevent="contactFilterValue(item.id)">
                                        {{ item.value }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="card-body">
                            <app-chart class="mb-primary"
                                       type="line-chart"
                                       :height="230"
                                       :labels="e_commerceDashboard.contactOverview.labels"
                                       :data-sets="e_commerceDashboard.contactOverview.chartData"/>
                            <div class="chart-data-list d-flex flex-wrap justify-content-center">
                                <div class="data-group-item" style="color: rgb(97, 177, 90);">
                                    <span class="square" style="background-color: rgb(97, 177, 90);"/>
                                    Customers
                                    <span class="value">{{e_commerceDashboard.contactOverview.customerCount}}</span>
                                </div>
                                <div class="data-group-item" style="color: rgb(14, 73, 181);">
                                    <span class="square" style="background-color: rgb(14, 73, 181);"/>
                                    Suppliers
                                    <span class="value">{{e_commerceDashboard.contactOverview.supplierCount}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->

                <div class="col-12">
                    <app-overlay-loader v-if="!isActiveTeamOverview && !mainPreloader"/>
                    <div class="card card-with-shadow border-0 h-100" v-if="isActiveTeamOverview">

                      <mysite-index/>
                      <div class="card-header p-primary bg-transparent d-flex align-items-baseline">
                            <h5 class="card-title m-0 d-inline-block">Sites Overview</h5>
                        </div>
                      <div class="card-body">
                            <app-chart type="bar-chart"
                                       :height="250"
                                       :labels="e_commerceDashboard.teamOverview.barChartLabels"
                                       :data-sets="e_commerceDashboard.teamOverview.datasetsBarChart"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import {FormMixin} from '../../../../../core/mixins/form/FormMixin';
    import {DashboardPreloader} from "./Mixins/DashboardPreloader";
    import * as actions from '../../../../Config/ApiUrl';
    import {numberFormatter, numberWithCurrencySymbol} from "../../../../Helpers/Helpers";
    import { axiosGet } from "../../../../Helpers/AxiosHelper";


    export default {
        name: "ClientDashboard",
        mixins: [FormMixin,DashboardPreloader],
        props: {
            package_id: Number,
        },
        data() {
            return {
                showProgress: false,
                formProgress: {},
                overallProgress: 0,
                taskForms: [],
                task_id: 0,
                // package_id: this.$store.state.user.loggedInUser.company,

                /* Loader section and active/inactive section */
                mainPreloader: true,

                isActivedDefaultiInfo: false,
                isActiveBusinessOverview: false,
                isActiveContactOverview: false,
                isActiveTeamOverview: false,
                /* end */

                e_commerceDashboard: {},
                businessFilter: 'this_week',
                contactFilter: 'this_week',
            }
        },
        created() {
            this.teamOverview();
            this.ecommerceDefaultInfo();
            this.businessOverview();
            this.contactOverview();
            setTimeout(() => {
                this.getProgress();

            }, 2000)
        },
        methods: {
            getProgress() {
                axiosGet(actions.GET_PACKAGE_TASK + "/" + this.package_id)
                .then((response) => {
                    if (response.data) {
                        this.task_id = response.data.task.id;
                      this.taskForms = response.data.task.task_forms_list;
                      this.taskFormStatus = response.data.task.task_forms_list;
                        this.formProgress = response.data.formsProgress;
                        this.overallProgress = response.data.overallProgress;
                        this.showProgress = true;
                    }
                })
                .catch((error) => {

                });
            },
            businessFilterValue(item) {

                this.businessFilter = item;
                this.isActiveBusinessOverview = false;
                this.businessOverview();

            },
            contactFilterValue(item) {

                this.contactFilter = item;
                this.isActiveContactOverview = false;
                this.contactOverview();

            },
            ecommerceDefaultInfo() {

                let url = actions.DEFAULT_INFO;
                this.axiosGet(url).then(response => {

                    this.e_commerceDashboard.defaultInfo = response.data;
                    this.isActivedDefaultiInfo = true;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.countCreatedResponse++;
                });
            },
            businessOverview() {

                let url = actions.BUSINESS_OVERVIEW, reqData = {};
                reqData.params = {
                    key: this.businessFilter
                };

                this.axiosGet(url, reqData).then(response => {

                    this.e_commerceDashboard.businessOverview = response.data;
                    this.isActiveBusinessOverview = true;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.countCreatedResponse++;
                });
            },
            contactOverview() {

                let url = actions.CONTACT_OVERVIEW, reqData = {};

                reqData.params = {
                    key: this.contactFilter
                };

                this.axiosGet(url, reqData).then(response => {

                    this.e_commerceDashboard.contactOverview = response.data;
                    this.isActiveContactOverview = true;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.countCreatedResponse++;
                });
            },
            teamOverview() {

                let url = actions.TEAM_OVERVIEW;

                this.axiosGet(url).then(response => {

                    this.e_commerceDashboard.teamOverview = response.data;
                    this.isActiveTeamOverview = true;

                }).catch(({response}) => {

                }).finally(() => {
                    this.mainPreloader = false;
                    this.countCreatedResponse++;
                });
            },
            numberFormat(value) {
                return numberFormatter(value);
            },

            currencyFormat(value) {
                return numberWithCurrencySymbol(value);
            }
        },
        computed: {
            userRole() {
            return this.$store.state.user.loggedInUser;
            },
            userId() {
            return this.$store.state.user.loggedInUser.id;
            },
  },
    }
</script>
<style>

</style>
